/*
 *  Copyright 2022 Collate.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *  http://www.apache.org/licenses/LICENSE-2.0
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

import React from "react";
import { ErrorBoundary as ErrorBoundaryWrapper } from "react-error-boundary";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "utils/constants/route.constants";
import ErrorFallback from "./ErrorFallback.component";

const ErrorBoundary = ({ children }) => {
  const navigate = useNavigate();

  const onErrorReset = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <ErrorBoundaryWrapper
      FallbackComponent={ErrorFallback}
      onReset={onErrorReset}
    >
      {children}
    </ErrorBoundaryWrapper>
  );
};

export default ErrorBoundary;
